/* eslint-disable no-sparse-arrays */
import { all } from "redux-saga/effects";
import watchSetPassword from "./activationPage/saga/watcher";
import watchAddTenantUser from "./addTenantUser/saga/watcher";
import watchSignin from "./signin/saga/watcher";
import watchSignup from "./signup/saga/watcher";
import {
  watchTenantDetail,
  watchTenantList,
  watchTenantRow,
  watchUserRow,
} from "./tenant/saga/watcher";
import { watchProductList } from "./product/saga/watcher";
import watchTenantUserList from "./tenantUserList/saga/watcher";
import watchCreateproduct from "./createprod/saga/watcher";
import { watchCheckout } from "./checkout/saga/watcher";

export default function* rootSaga() {
  yield all([
    watchProductList(),
    watchSignup(),
    watchSetPassword(),
    watchTenantList(),
    watchTenantDetail(),
    watchTenantRow(),
    watchUserRow(),
    watchTenantUserList(),
    watchSignin(),
    watchAddTenantUser(),
    watchCreateproduct(), ,
    watchCheckout(),
  ]);
}
